// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"250":"84ab19d7","742":"cbda3ef6","924":"2c54a16c"}[chunkId] + ".chunk.css";
};